import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import fcAuth from '@feathersjs/authentication-client'
import io from 'socket.io-client'
import { invalidateQuery } from './QueryCache'

// const isDev = !(window._env_ && window._env_.NODE_ENV && window._env_.NODE_ENV === 'production')
const API_BASE_URL = window._env_ && window._env_.API_BASE_URL ? window._env_.API_BASE_URL : 'http://localhost:3000'

const FC = {
  socketConfig: {
    timeout: 60000,
    pingInterval: 5000,
    pingTimeout: 20000
  },
  socket: io(API_BASE_URL),
  client: feathers(),
  authenticated: false,
  online: false,
  isDev: true,
  connectionHandler: (event) => () => {
    FC.isDev && console.log(`Socket ${event} to ${API_BASE_URL}`)
    FC.online = event === 'connect'
  }
}

FC.client.configure(socketio(FC.socket, FC.socketConfig))
FC.client.configure(fcAuth({ storage: new fcAuth.MemoryStorage() }))
FC.socket.on('connect', FC.connectionHandler('connect'))
FC.socket.on('disconnect', FC.connectionHandler('disconnect'))

const queryToInvalidate = [
  { roles: ['admin', 'operatore'], query: 'conversations' },
  { roles: ['admin', 'operatore'], query: 'conversation' },
  { roles: ['admin'], query: 'processSteps' },
  { roles: ['admin'], query: 'getStats' }
]

FC.addListeners = () => {
  FC.client.service('processStep').on('created', () => {
    const { user: { role = '' } = {} } = JSON.parse(window.localStorage.getItem('user')) || {}
    invalidateQuery(queryToInvalidate.filter(({ roles }) => roles.includes(role)).map(({ query }) => query))
  })
  FC.client.service('process').on('patched', () => {
    const { user: { role = '' } = {} } = JSON.parse(window.localStorage.getItem('user')) || {}
    invalidateQuery(queryToInvalidate.filter(({ roles }) => roles.includes(role)).map(({ query }) => query))
  })
  FC.client.service('messages').on('created', (message) => {
    const { user: { id = '' } = {} } = JSON.parse(window.localStorage.getItem('user')) || {}
    if (message.sender !== 'operator' || message.userId !== id) return null
    window.growl.show({ severity: 'success', summary: 'Messaggio inviato', detail: 'Messaggio inviato con successo' })
  })
  FC.client.service('messages').on('patched', () => {
    const { user: { role = '' } = {} } = JSON.parse(window.localStorage.getItem('user')) || {}
    invalidateQuery(queryToInvalidate.filter(({ roles }) => roles.includes(role)).map(({ query }) => query))
  })
  FC.isDev && console.log('FC Authenticated & Listening for events')
}

FC.stopListeners = () => {
  FC.client.service('processStep').removeListener('created')
  FC.isDev && console.log('FC Stopped listening for events')
}

FC.login = async (credentials) => {
  try {
    const response = await FC.client.authenticate(credentials)
    FC.authenticated = !!response.accessToken
    FC.authenticated && FC.addListeners()
    return response
  } catch (details) {
    FC.error = details
    return false
  }
}

FC.logout = async () => {
  FC.stopListeners()
  FC.client.logout()
  FC.authenticated = false
  invalidateQuery(queryToInvalidate.map(({ query }) => query))
}

FC.service = (...params) => FC.client.service(...params)

FC.isReady = () => FC.online && FC.authenticated

export { FC }
